import { ApiObjectService } from './api-object.service'

class EquipmentItemsService extends ApiObjectService {
    namespace = 'equipment-items'
}

export const equipmentItemsService = new EquipmentItemsService()
